import {styled} from "@mui/system";
import InputBase from "@mui/material/InputBase";
import {Typography, useTheme} from "@mui/material";
import {useState} from "react";
import {useSelector} from "react-redux";
import {formatPrice, getDefaultCurrency} from "../../helpers";

const InputWrapper = styled("div")(({theme}) => ({
    padding: "2px 4px",
    border: `solid 2px ${theme.palette.disabled.contrastText}`,
    display: "flex",
    borderRadius: theme.shape.borderRadius,
    alignItems: "center",
    width: "100%",
}));
const LabelComponent = styled("div")(({theme}) => ({
    display: "flex",
    // justifyContent: 'space-between',
    // width: '150px',
    marginBottom: "10px",
}));
const Spacer = styled("div")(({theme}) => ({
    padding: "5px",
}));
const IconContainer = styled("div")(({theme}) => ({
    padding: "5px",
}));

const InputContainer = styled("div")(({theme}) => ({
    width: "100%",
    // display: "grid",
    justifyContent: "space-between",
    // gridTemplateColumns: "82% 15%",
}));

const invertPrice = (price: string | number) => {
    try {
        if (!price) return 0;
        return 1 / Number(price);
    } catch {
        return 0;
    }
};

const CurrencyInput = ({
                           Flag,
                           sign,
                           label,
                           // placeHolder,
                           handleChange,
                           handleSwitch,
                           switched,
                           id,
                           value,
                           touched,
                       }: {
    Flag?: React.FC | undefined;
    sign?: string;
    label?: string;
    // placeHolder?: string
    handleChange: (id: number, value: number, switched: boolean) => void;
    handleSwitch: (id: number) => void;
    id: number;
    switched: boolean;
    value: number;
    touched?: boolean;
}) => {
    const [itemValue, setItemValue] = useState(value);
    const [focused, setFocused] = useState(false);
    // const [switched, setSwitched] = useState(false)

    const business = useSelector((state: any) => state).businessReducer.business;
    const {currencies} = useSelector((state: any) => state).currencyReducer;

    const defaultCurrency = getDefaultCurrency(business.business.default_currency_id, currencies);
    const localCurrency = defaultCurrency.fa_title;
    const localCurrencySign = defaultCurrency.en_title;

    const placeHolder = `${formatPrice(value)} ${switched ? sign : localCurrencySign}`;
    const theme = useTheme();

    return (
        <>
            <LabelComponent>
                <Typography variant="body2">{switched ? localCurrency : label}</Typography>
                <Spacer/>
                <Typography color={theme.palette.disabled.main} variant="body2">
                    به
                </Typography>
                <Spacer/>
                <Typography variant="body2">{switched ? label : localCurrency}</Typography>
            </LabelComponent>
            <InputContainer>
                <InputWrapper>
                    <IconContainer>
                        {/*{switched ? <Iran/> : (Flag ? <Flag/> : null)}*/}
                        {Flag ? <Flag/> : null}
                    </IconContainer>
                    <InputBase
                        sx={{ml: 1, flex: 1}}
                        // type="number"
                        // @ts-ignore
                        onChange={(e) => setItemValue(e.target.value)}
                        // @ts-ignore
                        onBlur={(e) => {
                            handleChange(id, itemValue, switched);
                        }}
                        onFocus={(e) => setFocused(true)}
                        // value={focused ? switched ? invertPrice(itemValue) : itemValue : null}
                        value={focused ? formatPrice(itemValue) : null}
                        placeholder={placeHolder}
                        inputProps={{"aria-label": "search google maps"}}
                    />
                    <IconContainer>
                        <Typography variant="body2">= {switched ? localCurrencySign : sign} 1</Typography>
                    </IconContainer>
                </InputWrapper>
                {/*<Button*/}
                {/*  disableRipple*/}
                {/*  onClick={() => {*/}
                {/*    handleChange(id, itemValue, !switched);*/}
                {/*    handleSwitch(id);*/}
                {/*  }}*/}
                {/*  sx={{ borderWidth: "2px" }}*/}
                {/*  variant="outlined"*/}
                {/*>*/}
                {/*  <TransferIcon />*/}
                {/*</Button>*/}
            </InputContainer>
        </>
    );
};

export default CurrencyInput;
